module.exports = __webpack_public_path__ + "static/media/laugh_yenia2.93dcfa97.mp3";